<template>
  <div>
    <h1>{{this.$t('error-page-title')}}</h1>
    <div v-html="this.$t('error-page-content')"></div>
  </div>
</template>

<script>
export default {
  name: 'not-found',
  props: {
    context: {
      type: Object,
    },
  },
};
</script>
